<template>
  <b-row>
    <b-col>
      <div class="p-3" :class="{ 'raised rounded': raised }">
        <generic-entity-upload-documents
          ref="documents"
          :files="salesforce_documents"
          :uploadUrl="`users/${user.id}/entities/${entity.id}/docs`"
          @upload-success="loadEntities"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import TitleContainer from '@/components/utils/TitleContainer';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import ExplicitHint from '@/components/utils/hints/ExplicitHint';
import FilterTable from '@/components/utils/FilterTable';
import Upload from '@/components/utils/upload/Upload';
import SentFilesModal from '@/components/documents/SentFilesModal';
import SimpleTitle from '@/components/utils/SimpleTitle';
import { DEFINE_ENTITIES } from '@/vuex/modules/entities/types/actions';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import GenericEntityUploadDocuments from '@/components/entities/documents/GenericEntityUploadDocuments';

library.add(faDownload);

export default {
  components: {
    GenericEntityUploadDocuments,
    TitleContainer,
    DocumentsLegend,
    ExplicitHint,
    FilterTable,
    Upload,
    SentFilesModal,
    SimpleTitle,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    raised: {
      type: Boolean,
      default: true,
    },
    showHint: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  name: 'EntityDocuments',
  data() {
    return {
      modalRecord: {},
      uploadParams: {},
      showUploadModal: false,
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
      fields: [
        { key: 'type', label: 'Document Type', sortable: true },
        { key: 'upload', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'download_template', label: 'Download Template', thClass: 'text-center', tdClass: 'text-center' },
      ],
      templates: [
        { key: 'type' },
        { key: 'upload' },
        { key: 'download_template' },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    documents() {
      return this.entity.docs;
    },
    salesforce_documents() {
      const index = Object.keys(this.documents).filter(i => this.documents[i].type === 'Salesforce');
      if (index.length) {
        return this.documents[index[0]].files;
      }

      return [];
    },
  },
  methods: {
    loadEntities() {
      this.$reqs.get(`/users/${this.user.id}/entities`).then((response) => {
        this.$store.dispatch(DEFINE_ENTITIES, response.data);
      })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.icon-upload {
  color: #3e88c9;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/EntityDocuments.vue